export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = "https://apinew.testqmeter.net/api/v1"; 

export const RATE_SCORE = {
  very_bad: -10,
  unacceptable: -10,
  bad: -5,
  neutral: 0,
  good: 5,
  excellent: 10,
};

export const fontSize = {
  S: 16,
  M: 25.89,
  // L: 32,
  L: 41.8,
};

export const smileySizes = {
  S: 70,
  M: 100,
  L: 150,
};

export const logoHolderHeightSizes = {
  S: 80,
  M: 100,
  L: 120,
};
export const logoHolderPaddingSizes = {
  S: "20px 0",
  M: "25px 0",
  L: "30px 0",
};
